module.exports = __webpack_public_path__ + "img/v4_nodata.d6a8175f.png";